import React from "react";
import "./TextInput.css";

class TextInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFocused: false,
    };
    this.handleOnFocus = this.handleOnFocus.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
  }

  handleOnFocus() {
    this.setState({
      isFocused: true,
    });
  }

  handleOnBlur() {
    this.setState({
      isFocused: false,
    });
  }

  render() {
    return (
      <div className="text-input">
        <label htmlFor={this.props.id}>{this.props.label}</label>
        <input
          type={this.props.type}
          id={this.props.id}
          placeholder={this.props.placeholder}
          value={this.props.value}
          name={this.props.id + "-text-input"}
          onChange={this.props.handleTextInputOnChange}
          onFocus={this.handleOnFocus}
          onBlur={this.handleOnBlur}
          spellCheck={false}
          required={this.props.required}
        />
        <div className="focus-bar">
          <span className="normal-state-bar"></span>
          <span
            className={
              this.state.isFocused
                ? "focus-state-bar focused"
                : "focus-state-bar"
            }
          ></span>
        </div>
      </div>
    );
  }
}

export default TextInput;
